"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminLockAccountRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class AdminLockAccountRequestDto {}
exports.AdminLockAccountRequestDto = AdminLockAccountRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Mandatory reason for locking the account (audit log and lockout record).',
  minLength: 1
}), __metadata("design:type", String)], AdminLockAccountRequestDto.prototype, "reason", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Lock duration in minutes. If omitted (and permanentUntilManualUnlock is false), the server uses the same default as anti-spoofing locks (typically 24 hours, configurable via ANTI_SPOOFING_LOCK_MINUTES).',
  required: false,
  minimum: 1
}), __metadata("design:type", Number)], AdminLockAccountRequestDto.prototype, "lockDurationMinutes", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'If true, the account remains locked until an admin unlocks it (implemented as a very long temporary lockout). Ignores lockDurationMinutes.',
  required: false,
  default: false
}), __metadata("design:type", Boolean)], AdminLockAccountRequestDto.prototype, "permanentUntilManualUnlock", void 0);
//# sourceMappingURL=AdminLockAccountRequest.dto.js.map